
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/home-modifications-for-wounded-warriors",
      function () {
        return require("private-next-pages/articles/home-modifications-for-wounded-warriors.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/home-modifications-for-wounded-warriors"])
      });
    }
  